import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as AdditionalInformationActions from '../actions/additional-information.actions';
import { AdditionalInformationHttpService } from '@feature/_app_modules/additional-information/services/additional-information-http.service';

@Injectable()
export class AdditionalInformationEffects {
  constructor(
    private readonly actions: Actions,
    private readonly additionalInformationService: AdditionalInformationHttpService
  ) { }

  loadUserSelectedGroups = createEffect(() => this.actions.pipe(
    ofType(AdditionalInformationActions.loadUserSelectedGroups),
    mergeMap(action => {
      return this.additionalInformationService.getUserSelectedGroups({
          Key: action.key,
          DashboardWidgetId: action.dashboardWidgetId
        }
      ).pipe(map(groups => AdditionalInformationActions.loadUserSelectedGroupsComplete({ dashboardWidgetId: action.dashboardWidgetId, userSelectedGroups: groups }))
      );
    })
  ));

  loadAdditionalInformationDetails = createEffect(() => this.actions.pipe(
    ofType(AdditionalInformationActions.loadDetails),
    mergeMap(action => {
      return this.additionalInformationService.getAdditionalInformation({
        Key: action.key,
        DashboardWidgetId: action.dashboardWidgetId
        }
      ).pipe(map(details => AdditionalInformationActions.loadDetailsComplete({ dashboardWidgetId: action.dashboardWidgetId, details: details }))
      );
    })
  ));
}
